import { genericApplicationMessage } from '@cdf/api-client-react';
import { formatDateTime as displayDateTime } from '@/lib/site-time';

export const TENANT_PERMISSION_GROUPS = [
  {
    label: 'People',
    permissions: [
      ['tenant.members.read', 'View members'],
      ['tenant.members.manage', 'Manage members'],
      ['tenant.invites.create', 'Create invites'],
      ['tenant.invites.read', 'View invites'],
      ['tenant.invites.revoke', 'Revoke invites']
    ]
  },
  {
    label: 'Administration',
    permissions: [
      ['tenant.roles.read', 'View roles'],
      ['tenant.roles.manage', 'Manage custom roles'],
      ['tenant.modules.manage', 'Manage modules'],
      ['tenant.settings.read', 'View settings'],
      ['tenant.settings.manage', 'Manage settings']
    ]
  },
  {
    label: 'Oversight',
    permissions: [
      ['tenant.audit.read', 'View audit history'],
      ['tenant.elevation.request', 'Request elevated access'],
      ['tenant.elevation.approve', 'Approve elevated access']
    ]
  }
] as const;

export const TENANT_PERMISSION_KEYS = TENANT_PERMISSION_GROUPS.flatMap((group) =>
  group.permissions.map(([key]) => key)
);

export function hasTenantPermission(permissions: readonly string[], permission: string): boolean {
  return permissions.includes('*') || permissions.includes(permission);
}

export function formatTenantStatus(status: string): string {
  return `${status.slice(0, 1).toUpperCase()}${status.slice(1)}`;
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.valueOf())
    ? '—'
    : displayDateTime(date);
}

export function messageFromError(error: unknown, fallback = 'Something went wrong. Please try again.'): string {
  return genericApplicationMessage(error instanceof Error && error.message ? error.message : fallback);
}
